import { createVuetify } from 'vuetify';

import { vuetifyOptions } from '@abaninja/util-vuetify-config';

export const vuetify = createVuetify(vuetifyOptions);
